import { useDispatch, useSelector } from "react-redux";
import { Feedback } from "../../../..";
import { IAppState } from "../../../../../Common";
import {
  ISetSearchSavedFiltersArguments,
  IUpdateListItemArguments,
  setSavedFilters,
  updateListItem as updateListItemActionCreator
} from "../../../../Actions/FeedbackListActions";

export const useFeedbackList = (listId: string) => {
  const list = useSelector((state: IAppState) => {
    if (state.feedbackLists.lists[listId] !== undefined) {
      return {
        items: state.feedbackLists.lists[listId].feedbacks,
        fullResultsCount: state.feedbackLists.lists[listId].fullResultsCount,
        isLoaded: state.feedbackLists.lists[listId].isLoaded,
        isLoading: state.feedbackLists.lists[listId].isLoading,
        isErrored: state.feedbackLists.lists[listId].isErrored,
        errorMessage: state.feedbackLists.lists[listId].errorMessage,
        errorCode: state.feedbackLists.lists[listId].errorCode,
        areTransitionsLoaded: state.feedbackLists.lists[listId].areTransitionsLoaded,
        areTransitionsLoading: state.feedbackLists.lists[listId].areTransitionsLoading,
        tagState: state.tags,
        user: state.oidc.user,
        savedFilters: state.feedbackLists.lists[listId].savedFilters,
        isInitialFilterSaved: state.feedbackLists.lists[listId].isInitialFilterSaved
      };
    }
    // the record for this feedback list does not exist, assume a default value
    return {
      items: null,
      fullResultsCount: 0,
      isLoaded: false,
      isLoading: false,
      isErrored: false,
      areTransitionsLoaded: false,
      areTransitionsLoading: false,
      tagState: state.tags,
      user: state.oidc.user,
      savedFilters: null,
      isInitialFilterSaved: false
    };
  });

  const dispatch = useDispatch();

  const updateListItem: (args: IUpdateListItemArguments) => void = args =>
    dispatch(updateListItemActionCreator(args));

  const updateSavedFilters: (args: ISetSearchSavedFiltersArguments) => void = args =>
    dispatch(setSavedFilters(args));

  return {
    list,
    updateListItem,
    updateSavedFilters
  };
};
